export const Questions = {
    question1: [
        {
            key: 'Не стану выяснять отношения — я выше этого!',
            value: 'q1Radio1'
        },
        {
            key: 'Попытаюсь задеть за живое — пусть знает, с кем связался.',
            value: 'q1Radio2'
        },
        {
            key: 'Просто кивну и улыбнусь. Это жизнь — бывает!',
            value: 'q1Radio3'
        },
        {
            key: 'Наверняка приму его слова близко к сердцу.',
            value: 'q1Radio4'
        },
        {
            key: 'Объясню человеку, почему он не прав.',
            value: 'q1Radio5'
        }
    ],
    question2: [
        {
            key: 'Вечеринка года: куча людей, музыка, выпивка, веселье!',
            value: 'q2Radio1'
        },
        {
            key: 'Поехать с друзьями в ночной клуб и танцевать всю ночь напролет',
            value: 'q2Radio2'
        },
        {
            key: 'В кругу семьи и близких друзей',
            value: 'q2Radio3'
        },
        {
            key: 'Только я и мой любимый человек',
            value: 'q2Radio4'
        },
        {
            key: 'Я не люблю праздновать — это обычный день',
            value: 'q2Radio5'
        }
    ],
    question3: [
        {
            key: 'Достичь высокого статуса в обществе',
            value: 'q3Radio1'
        },
        {
            key: 'Получать удовольствие от жизни',
            value: 'q3Radio2'
        },
        {
            key: 'Максимально реализовать свой потенциал',
            value: 'q3Radio3'
        },
        {
            key: 'Стать хорошим родителем',
            value: 'q3Radio4'
        },
        {
            key: 'Построить успешную карьеру',
            value: 'q3Radio5'
        }
    ],
    question4: [
        {
            key: 'Коммуникабельность',
            value: 'q4Radio1'
        },
        {
            key: 'Проактивность',
            value: 'q4Radio2'
        },
        {
            key: 'Мудрость',
            value: 'q4Radio3'
        },
        {
            key: 'Искренность',
            value: 'q4Radio4'
        },
        {
            key: 'Рациональность',
            value: 'q4Radio5'
        }
    ],
    question5: [
        {
            key: 'Высокомерие',
            value: 'q5Radio1'
        },
        {
            key: 'Раздражительность',
            value: 'q5Radio2'
        },
        {
            key: 'Мягкосердечность',
            value: 'q5Radio3'
        },
        {
            key: 'Импульсивность',
            value: 'q5Radio4'
        },
        {
            key: 'Сдержанность',
            value: 'q5Radio5'
        }
    ],
    question6: [
        {
            key: 'Курсы актерского мастерства',
            value: 'q6Radio1'
        },
        {
            key: 'Занятия спортом',
            value: 'q6Radio2'
        },
        {
            key: 'Танцы или рисование',
            value: 'q6Radio3'
        },
        {
            key: 'Рукоделие: вязание, вышивание, плетение',
            value: 'q6Radio4'
        },
        {
            key: 'Шахматы',
            value: 'q6Radio5'
        }
    ],
    question7: [
        {
            key: 'Организатором всех школьных мероприятий',
            value: 'q7Radio1'
        },
        {
            key: 'Прогульщиком/прогульщицей',
            value: 'q7Radio2'
        },
        {
            key: 'Душой компании',
            value: 'q7Radio3'
        },
        {
            key: 'Объектом подшучиваний',
            value: 'q7Radio4'
        },
        {
            key: 'Участником интеллектуальных соревнований',
            value: 'q7Radio5'
        }
    ],
    question8: [
        {
            key: 'Не особо, просто иногда интересно послушать гороскоп',
            value: 'q8Radio1'
        },
        {
            key: 'Нет. Но, когда нужно, я читаю про совместимость знаков зодиака',
            value: 'q8Radio2'
        },
        {
            key: 'Скорее да. Иногда жизнь так складывается, что трудно не верить в высшие силы',
            value: 'q8Radio3'
        },
        {
            key: 'Да, даже был опыт общения с астрологом/экстрасенсом',
            value: 'q8Radio4'
        },
        {
            key: 'Нет — нужно верить только в собственные силы',
            value: 'q8Radio5'
        }
    ],
};